// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import Login from "components/user/Login";
import Block from "components/layout/Block";
import UserAvatar from "components/user/UserAvatar";

// ** Custom Hooks
import useBreakpoint from "hooks/useBreakpoint";

// ** Utils & Helpers
import { VIP_STATUS } from "helpers/constants";

// #####################################################

const FirstRightMessageLayout = () => {
	const isPhone = useBreakpoint("phone", "max");
	const user = useSelector((state) => state.globalUser);

	return (
		<Block flex mb={1}>
			<Login
				link
				login={user.login}
				vip={
					user?.showStatusVip === false
						? user.status_vip > VIP_STATUS.VERIFIED
							? VIP_STATUS.VERIFIED
							: user.status_vip
						: user.status_vip
				}
				oneLine={!isPhone}
				maxWidthWithEllipsis={isPhone ? 200 : 400}
				size="xsmall"
				vipProps={{ noPad: true, leftPad: 1 }}
				customMargin="0 0.75rem 0 0 "
			/>
			<UserAvatar
				userId={user?.id}
				size="xsmall"
				link
				src={user.avatar}
				login={user.login}
				online={user.online}
				privateData={user.private_data || user.privateData}
				status={user.profile_status || user.profileStatus}
			/>
		</Block>
	);
};

export default FirstRightMessageLayout;
